// Shared class builder for selectable quiz options (true/false + MCQ).
// review: after submit the pick is locked and tinted by correctness.
export const optionClass = ({ selected, review, correct }) => {
  const base =
    "w-full text-start px-4 py-3 rounded-lg border transition-colors duration-150 text-white";
  if (review && selected) {
    return `${base} ${
      correct
        ? "border-green-500 bg-green-500/10"
        : "border-primary bg-primary/10"
    }`;
  }
  if (selected) return `${base} border-primary bg-primary/10`;
  return `${base} border-lightGrey bg-grey ${
    review ? "opacity-60" : "hover:border-primary"
  }`;
};
